import { ChangeEvent } from 'react';
import { Box, Icon } from '@nimbus-ds/components';
import { DiscountCircleIcon } from '@nimbus-ds/icons';
import { InputNumberNimbus } from 'commons/components';

interface InputPercentageWithErrorProps {
  hasError: boolean;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  discount: string;
  discountNumber: number | undefined;
  maxDiscount: number;
}

export function InputPercentageWithError({
  hasError,
  handleInputChange,
  discount,
}: Readonly<InputPercentageWithErrorProps>) {
  return (
    <Box>
      <InputNumberNimbus
        appearance={hasError ? 'danger' : 'neutral'}
        type="float"
        appendPosition="end"
        onChange={handleInputChange}
        append={<Icon source={<DiscountCircleIcon />} />}
        aria-label="discount-percentage"
        aria-describedby={hasError ? 'percentage-error' : undefined}
        defaultDecimals={0}
        value={discount}
        maxDigits={3}
      />
    </Box>
  );
}
